module.exports = __webpack_public_path__ + "media/images/mountines_2-3eb412aaadb11c75594b0f981be9a7a1.png";